import React, { Suspense, lazy } from 'react';
import { useRoutes, Navigate } from "react-router-dom";
import config from "./config";
import { CacheUtil } from "./utils/cache";


let routes = [
    {
        path: "/login",
        title: "登录",
        component: lazy(() => import('./pages/login')),
    },
    {
        path: "/",
        title: config.app_name,
        auth: true,
        component: lazy(() => import('./pages/home')),
        children: [
            {
                index: true,
                title: "大盘统计",
                component: lazy(() => import('./pages/dashboard')),
            },
            {
                path: "dashboard",
                title: "大盘统计",
                component: lazy(() => import('./pages/dashboard')),
            },
            {
                title: "任务管理",
                path: "builder",
                component: lazy(() => import('./pages/builder/index.js')),
                children: [
                    {
                        path: "",
                        component: () => <Navigate to="list" />,
                    },
                    {
                        path: "list",
                        title: "任务列表",
                        component: lazy(() => import('./pages/builder/components/list.js')),
                    },
                    {
                        path: "add",
                        title: "任务添加",
                        component: lazy(() => import('./pages/builder/components/edit.js')),
                    },
                    {
                        path: ":appId",
                        title: "任务查看",
                        component: lazy(() => import('./pages/builder/components/show.js')),
                    },
                ]
            },
            {
                path: "template-rules",
                title: "模板规则",
                component: lazy(() => import('./pages/template-rules')),
            },
            {
                path: "*",
                title: "页面未找到",
                component: lazy(() => import('./pages/not-found')),
            }
        ],
    },
];

const assembleRoute = (path: string, auth: boolean, routes: Array<any>) => {
    return routes.map((item: any) => {
        let thePath = path + '/' + item.path;
        thePath     = thePath.replace(/\/\/+/g, "/");
        item.auth   = item.auth ? item.auth : auth;
        item.to     = thePath;
        if (item.children) {
            item.children = assembleRoute(thePath, item.auth, item.children);
        }
        return item;
    });
}

routes = assembleRoute("/", false, routes);

// 生成路由
function genRoutes(routes: any) {
    const list = [];
    // eslint-disable-next-line array-callback-return
    routes.map((item: any) => {
        const obj = { ...item };
        obj.element = <Suspense fallback={<div style={{display: 'flex'}}></div>}>
            <obj.component />
        </Suspense>;
        if (obj.children) {
            obj.children = genRoutes(obj.children);
        }
        ['component', 'title', 'auth'].forEach(name => delete obj[name]);
        list.push(obj);
    });
    return list;
}

const Router = () => useRoutes(genRoutes(routes));

function comparePath(pathname: string, path: string) {
    if (path.indexOf(":") !== -1) {
        const patt = /\/:\w+/g;
        const regexStr = '^' + path.replace(patt, "/\\w+").replace(/\//g, '\\/') + '$';
        return new RegExp(regexStr).test(pathname);
    } else {
        return pathname === path;
    }
}


// 根据路径查找路由
const searchRoute = (pathname: string, routes: Array<any>) => {
    for (const item of routes) {
        if (comparePath(pathname, item.to)) return item;
        if (item.children) {
            const res = searchRoute(pathname, item.children);
            if (res) return res;
        }
    }
    return null;
};

const CheckRouter = (pathname: string) => searchRoute(pathname, routes)


const OnRouterBefore = function ({navigate, location, routerParams}) {
    let r = CheckRouter(location.pathname);
    console.log('onRouterBefore location.pathname: ', location.pathname);
    if (r && r.title) {
        document.title = r.title || config.app_name;
    }
    if (r && r.to === '/login') {
        return;
    }

    // return;
    if (r && r.auth) {
        // token权限验证
        const token = (new CacheUtil()).getExpire('token') || '';
        if (!token) {
            navigate('/login', {replace: true});
        }
    }
}

export { Router, CheckRouter, OnRouterBefore }

